/** @file Deletes an animation; mix defaults and direction fixes that name it are dropped with it. */
import { defineRemove } from '../_shared/defineRemove';

/** animation.delete: removeEntity strips the mixDefaults pairs and direction-fix entries that used it. */
export const command = defineRemove({
  domain: 'animation',
  kind: 'animation',
  description: 'Delete an animation (name or id); mixDefaults pairs and direction fixes that use it are removed too.',
});
